<template>
  <div class="sensitiveWord-item" v-bitmap="getListResult">
    <sensitiveWordList
      :sensitiveWordList="sensitiveWordData"
      class="sensitiveWord-list-content-main"
      :editShow="editShow"
      @reviseShowType="reviseShowType"
      @reviseWord="reviseWord"
      @delWords="delWords"
      :checkAll="checkAll"
      @deleteBatchList="deleteBatchList"
    />
    <pagination
      :pageSize="pageSize"
      :total="total"
      @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"
    ></pagination>
  </div>
</template>

<script>
import sensitiveWordList from "../sensitiveWord-list/sensitiveWord-list.vue";

export default {
  data() {
    return {};
  },
  components: {
    sensitiveWordList,
  },
  created() {
  },
  props: {
    sensitiveWordData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    getListResult: {
      type: String,
    },
    pageSize: {
      type: Number,
    },
    total: {
      type: Number,
    },
    editShow: {
      type: String
    },
    checkAll: {
      type: Boolean
    }
  },
  methods: {
    // 分页
    currentPageNumChange(e) {
      this.$emit("pageNum", e);
    },
    handleSizeChange(pageSize) {
      this.$emit("pageSize", pageSize);
    },
    reviseShowType(e){
      this.$emit("reviseShowType", e);
    },
    reviseWord(e){
      this.$emit("reviseWord",e);
    },
    delWords(e){
      this.$emit("delWords",e);
    },
    // 批量删除数据
    deleteBatchList(e){
      this.$emit('deleteBatchList',e);
    },
    // deleteBatchAllType(e){
    //   this.$emit("deleteBatchAllType",e);
    // }
  },
};
</script>

<style lang="sass" scoped>
@import "./sensitiveWord-item.scss"
</style>